import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/repo/apps/web/components/ui/badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/repo/apps/web/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-_487acc8f59a372d3e0c61af5d066cbfb/node_modules/next/dist/client/link.js");
